export const isAppleMapsSupported = () => {
  if (typeof navigator !== 'undefined' && navigator.platform) {
    return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
  }
  return false
}
